import React from 'react';
import { NavLink, Link } from "react-router-dom";
import logoSrc from '../assets/logo.svg';
import logotipoSrc from '../assets/logotipo.svg';
import menuSrc from '../assets/menu-black-18dp.svg';
import { FormattedMessage } from 'react-intl';
import LanguageSwitcher from './LanguageSwitcher';

const Header = (props) => {

   const clickMenuIcon = () => {
      var menuLinkList = document.getElementById('menu-links__list')
      if (menuLinkList.className === "menu-links__list") {
         menuLinkList.className = "responsive"
      } else {
         menuLinkList.className = "menu-links__list"
      }
   }

   return (
      <header className="header">
         <div className="container">
            <div className="row align-bottom">
               <div className="col-md-2">
                  <Link to="/" className="logo">
                     <img className="logo__logo" src={logoSrc} alt="" />
                     <img className="logo__logotipo" src={logotipoSrc} alt="" />
                  </Link>
               </div>
               <div className="header__menu-container col-md-10">
                  <nav className="menu-links">
                     <ul className="menu-links__list" id="menu-links__list">
                        <li className="icon" onClick={clickMenuIcon}>
                           <img src={menuSrc} alt="ícone do menu" />
                        </li>
                        <li className="menu-links__item menu-links__item--cta">
                           <NavLink className="menu-links__link" to="/sobre"><FormattedMessage id="sobre.h1"/></NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">
                           <NavLink className="menu-links__link" to="/informacoes-importantes"><FormattedMessage id="infos.h1"/></NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">
                           <NavLink className="menu-links__link" to="/se-sente-vulneravel"><FormattedMessage id="vulnerabilidade.h1"/></NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">
                           <NavLink className="menu-links__link" to="/meus-direitos"><FormattedMessage id="direitos.h1"/></NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">
                           <NavLink className="menu-links__link" to="/equipe"><FormattedMessage id="equipe.h1"/></NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">
                           <NavLink className="menu-links__link" to="/contato"><FormattedMessage id="contato.header"/></NavLink>
                        </li>
                        <li className="menu-links__item menu-links__item--cta">
                           <LanguageSwitcher toggleLanguage={props.toggleLanguage}/>
                        </li>
                     </ul>
                  </nav>
               </div>
            </div>
         </div>
      </header>
   )
}

export default Header;